import React from 'react';

export default ({ color }) => <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="m7.2 0v10.8h10.8v-10.8zm-3.6 7.2h-3.6v10.8h10.8v-3.6h-7.2z" fill={color}/></svg>;
